import React, { Component } from "react";
import { Row, Col, Container, Form, Button, Table, Image, Card } from "react-bootstrap";
// import SelectDropDown from '../selectdropdown/SelectDropDown';
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import MaterialCreationModal from './MaterialCreationModal';
import "./_materialAllocation.scss";
import Select from "react-select";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};


const CREATE_MEATRIALS_ALLCATION = gql`
mutation($params:CreateMaterialAllocation){
    createMaterialAllocation(params:$params)
}
`;

class MeatrialAssigning_to_Students extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStudentDetails: [],
            overAllstudentsDetails: props.getStudents,
            studentDetailsError: "",
            selectedMaterialType: "",
            overAllMaterialTypes: [],
            materialsTypesError: "",
            dataError: "",
            loading: 0,
            getAllocatedMaterials: [],
            is_exist: false,
            materialCreationModal: false,
            materialNameError: "",
            studentnameSearch: "0",
            studentnameSearchval: "",
            loadingSpinner: "",
            submitError: "",
            is_grouping: true
        };
    };


    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        //student name
        if (name == "studentnameSearch") {

            let studentnameSearchData = []

            if (value != "0") {
                this.getMaterialTypes();
                studentnameSearchData = this.state.overAllstudentsDetails.filter((item) => item.student_id == value);
                console.log("studentnameSearchData", studentnameSearchData);
                this.setState({
                    studentnameSearchval: {
                        value: studentnameSearchData[0].student_id,
                        label: `${studentnameSearchData[0].student_name}(${studentnameSearchData[0].roll_no})`
                    },
                    selectedStudentDetails: studentnameSearchData,
                    studentDetailsError: "",
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    overAllMaterialTypes: [],
                    submitError: "",
                });
            } else {
                this.setState({
                    studentnameSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    selectedStudentDetails: [],
                    studentDetailsError: "",
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    overAllMaterialTypes: [],
                    submitError: "",
                });
            }
        }

        this.setState({ [name]: value });

    };

    dropDownGetValues(fieldname) {
        let getArray = [];
        const newObj1 = {
            value: "0",
            label: "Select"
        }
        getArray.push(newObj1);
        if (fieldname == "studentnameSearch") {
            this.state.overAllstudentsDetails.map((stumap) => {
                const newObj = {
                    value: stumap.student_id,
                    label: `${stumap.student_name}(${stumap.roll_no})`
                }
                getArray.push(newObj);
            });
        }
        console.log("getArray", getArray);
        return getArray;
    };

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("name", name, value);

        if (name == "materialsTypes") {
            if (value != 0) {
                let grouping = this.state.overAllMaterialTypes.find((item) => item.id == value).is_grouping == 1 ? true : false

                this.setState({
                    selectedMaterialType: value,
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    submitError: "",
                    is_grouping: grouping
                })
            } else {
                this.setState({
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    submitError: "",
                    is_grouping: true
                })
            }

        }
    };

    getMaterialTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($id:Int){
                getMaterialTypes(id:$id){
                    id
                    material_type
                    is_grouping
                  }
               }
            `,
            variables: {
                id: 0,
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialTypes.length > 0) {
            let data = result.data.getMaterialTypes;
            console.log("data", data)
            this.setState({ overAllMaterialTypes: data })
        } else {
            this.setState({ overAllMaterialTypes: [] })
        }

    };

    getDisplayData = async (e) => {

        if (!this.state.selectedStudentDetails.length) {
            this.setState({ studentDetailsError: "Please Select Students", });
            return ""
        }

        if (this.state.selectedMaterialType === "" || this.state.selectedMaterialType === "--Select Materail--") {
            this.setState({ materialsTypesError: "Please Select Material Type ", variables: [] });
            return ""
        }


        // getMaterials

        this.setState({ loading: 1 });
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int,$material_type_id:Int){
                getMaterials(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,material_type_id:$material_type_id){
                    id
                    material_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(Cookies.get("branch_id")),
                exam_id: parseInt(this.state.is_grouping ? this.state.selectedStudentDetails[0].exam_id : ""),
                class_id: parseInt(this.state.is_grouping ? this.state.selectedStudentDetails[0].class_id : ""),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        })

        console.log("getMaterials", result);

        // getMaterialAllocationDetails



        const result1 = await this.props.client.query({
            query: gql`
            query($edu_student_id:Int,$material_type_id:Int){
                getMaterialAllocationDetails(edu_student_id:$edu_student_id, material_type_id:$material_type_id){
                    materials
                  }
               }
            `,
            variables: {
                edu_student_id: parseInt(this.state.selectedStudentDetails[0].student_id),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        })



        let overAllDetails = await Promise.all([{ getMaterials: result.data.getMaterials }, { getMaterialAllocationDetails: result1.data.getMaterialAllocationDetails }]);

        console.log("overAllDetails", overAllDetails);

        let getCombineMaterials = [];
        console.log("details", overAllDetails[1]);
        let materaialData = (overAllDetails[1]?.getMaterialAllocationDetails).length > 0 ? JSON.parse(overAllDetails[1]?.getMaterialAllocationDetails[0]?.materials) : []
        if (overAllDetails[0].getMaterials.length > 0) {

            if (materaialData.length > 0) {

                overAllDetails[0].getMaterials.map((item) => {
                    // let allocatedData =  overAllDetails[1]?.getMaterialAllocationDetails[0].materials.find((item1) => item1.material_id == item.id);
                    //  console.log("testing",JSON.parse(overAllDetails[1]?.getMaterialAllocationDetails[0]?.materials));
                    const allocatedData = materaialData.find((item1) => item1.material_id == item.id)

                    console.log("allocatedData", allocatedData);
                    if (allocatedData != null) {
                        let checked = false;
                        let disabled = false;

                        if (allocatedData.materialDeliveredTime != "") {
                            checked = true
                        }
                        if (allocatedData.materialDeliveredTime != "" && allocatedData.materialRecvAcceptTime != "") {
                            disabled = true
                        }
                        getCombineMaterials.push({ material_id: allocatedData.material_id, materialDeliveredTime: allocatedData.materialDeliveredTime, material_name: item.material_name, materialRecvAcceptTime: allocatedData.materialRecvAcceptTime, checked: checked, isDisabled: disabled })
                    } else {
                        getCombineMaterials.push({ material_id: item.id, materialDeliveredTime: "", material_name: item.material_name, materialRecvAcceptTime: "", checked: false, isDisabled: false })
                    }
                })

            } else {
                overAllDetails[0].getMaterials.map((item) => {
                    getCombineMaterials.push({ material_id: item.id, materialDeliveredTime: "", material_name: item.material_name, materialRecvAcceptTime: "", checked: false, isDisabled: false, materialNameError: "" })
                })
            }
        }

        this.setState({ getAllocatedMaterials: getCombineMaterials, loading: 0, is_exist: materaialData.length > 0 ? true : false, materialNameError: "", loader: 0, dataError: "No Data Found" });

    };

    handleSelectChekBoxChange = (e) => {
        const { name, value, checked } = e.target;
        console.log("nnnn", name, value, checked);

        let data = [];
        this.state.getAllocatedMaterials.map((item) => {
            if (item.material_id == value) {
                let time = ""
                if (checked) {
                    time = moment(new Date()).unix().toString()
                }
                data.push({ ...item, checked: checked, materialDeliveredTime: time })
            } else {
                data.push({ ...item })
            }
        });
        this.setState({ getAllocatedMaterials: data, materialNameError: "", submitError: "" })
    };

    onSubmittedDetails = () => {
        const errorValidation = this.state.getAllocatedMaterials.every((obj) => (
            obj.checked == false
        ));
        console.log("errorValidation", errorValidation);
        if (this.state.getAllocatedMaterials.length > 1 && errorValidation) {
            this.setState({
                submitError: 'Please Select at atleast one',
            });
            return ""
        }

        let data = [];

        this.state.getAllocatedMaterials.map((item) => {
            data.push({ material_id: item.material_id, material_name: item.material_name, materialDeliveredTime: item.materialDeliveredTime, materialRecvAcceptTime: item.materialRecvAcceptTime })
        })

        const params = {
            edu_student_id: parseInt(this.state.selectedStudentDetails[0].student_id),
            material_type_id: parseInt(this.state.selectedMaterialType),
            is_exist: this.state.is_exist,
            materials: JSON.stringify(data)
        }
        this.setState({ loadingSpinner: 1 })
        console.log("params", params);


        this.createMaterialAllocation(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                window.location.reload(false);
            }, 1500);
        });
    };

    createMaterialAllocation = async params => {
        await this.props.createMaterialAllocation({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data777", data);
                if (data.createMaterialAllocation) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
    };

    nextPage = () => {
        this.props.history.push({
            pathname: "/material-report",
            back: "/material-assigning"
        });
    }


    nextPageFunc = () => {
        this.props.history.push({
            pathname: "/material-store",
            back: "/material-assigning"
        });
    }

    render() {

        let StudentsFilterData = [];
        if (this.state.studentnameSearch != "0") {
            StudentsFilterData = this.state.overAllstudentsDetails
            if (this.state.studentnameSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.student_id == this.state.studentnameSearch);
            }
        } else {
            StudentsFilterData = this.state.overAllstudentsDetails
        }
        console.log("state121212", this.state);
        console.log("props", this.state);

        return (
            <Container className="">
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between bred_sec">
                            <h2 className="text-uppercase title h5 mb-0 tit_name" style={{ marginTop: "30px" }}>Materials Assignment</h2>
                            <div className='d-flex justify-content-end but_three'>
                                <div style={{ marginTop: "30px" }}>
                                    <button className="text-uppercase mat_ass" style={{ width: "163px" }} onClick={() => { this.setState({ materialCreationModal: true }) }}>Material Creation</button>
                                </div>
                                <div className='ml-2 but_two'>
                                    <button className="text-uppercase mat_ass" style={{ marginTop: "30px", width: "149px" }} onClick={() => this.nextPage()}>Material Report</button>
                                </div>
                                <div className='ml-2 but_two'>
                                    <button className="text-uppercase mat_ass" style={{ marginTop: "30px", width: "140px" }} onClick={() => this.nextPageFunc()}>Material Store</button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                        <Form.Label className="text-uppercase font-weight-bold" value="0">Select Students</Form.Label>
                        <SelectDropDown
                            stateData={this.state.studentnameSearchval}
                            handleChange={this.selecthandleInputChange}
                            name="studentnameSearch"
                            options={this.dropDownGetValues("studentnameSearch")}
                            placeholderName={'Student Name'}
                            dropdownIndicator={{ DropdownIndicator }}
                        />
                        <Form.Text className="form-text text-danger" type="invalid">
                            {this.state.studentDetailsError}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                        <Form.Label className="text-uppercase font-weight-bold">Material Type</Form.Label>
                        <Form.Control as="select" name="materialsTypes" onChange={this.handleInputChange} value={this.state.selectedMaterialType} isInvalid={this.state.materialsTypesError}>
                            <option value="0">--Select Material--</option>
                            {
                                this.state.overAllMaterialTypes.map((materials) => {
                                    return (
                                        <option key={materials.id} value={materials.id}>{materials.material_type}</option>
                                    )
                                })
                            }
                        </Form.Control>
                        <Form.Text className="form-text text-danger" type="invalid">
                            {this.state.materialsTypesError}
                        </Form.Text>
                    </Form.Group>

                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="Selectexam">
                        <Button className="text-uppercase submit_btn" onClick={this.getDisplayData}>get Details</Button>
                    </Form.Group>
                </Form.Row>
                <Row>
                    <Col>
                        {
                            this.state.loading == 1 ? (
                                <>
                                    <span className="spinner-border spinner-border-sm text-center spinner-alignment"></span>
                                </>

                            ) : (
                                <p>
                                    {
                                        this.state.getAllocatedMaterials.length > 0 ? (
                                            <>
                                                <Row>
                                                    <Col sm={6}>
                                                        <div className="mt-2">
                                                            <div>
                                                                {this.state.selectedStudentDetails.map(student => (
                                                                    <h5 key={student.student_id}>
                                                                        {student.student_name}      /     {student.class_name}     /     {student.section_name}
                                                                    </h5>
                                                                ))}
                                                                <Table className="table  table-bordered table-hover">
                                                                    <thead style={{ backgroundColor: "#213046", color: "#ffffff", textAlign: "center" }}>
                                                                        <tr >
                                                                            <th>Sno</th>
                                                                            <th>Material Name</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.getAllocatedMaterials.map((item, index) => (
                                                                            <tr key={item.material_id} className="text-center">
                                                                                <td>{index + 1}</td>
                                                                                <td>
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        name="checkOption"
                                                                                        id={item.material_id}
                                                                                        className="check"
                                                                                        onChange={(e) => this.handleSelectChekBoxChange(e)}
                                                                                        value={item.material_id}
                                                                                        label={item.material_name}
                                                                                        disabled={item.isDisabled}
                                                                                        checked={item.checked}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>

                                                                <Row>
                                                                    <Col sm={12} className="d-flex justify-content-end">
                                                                        <button className="mat_ass text-uppercase" onClick={this.onSubmittedDetails}>
                                                                            {
                                                                                this.state.loadingSpinner == 1 ? (
                                                                                    <span className="spinner-border spinner-border-sm"></span>
                                                                                ) : ""
                                                                            }
                                                                            Allocate</button>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={12} className="d-flex justify-content-end">
                                                                        {this.state.currentStep == 5 ? (
                                                                            <Form.Text className="form-text text-success mb-2 " >
                                                                                Material Allocation Successfully Submitted
                                                                            </Form.Text>
                                                                        ) : (
                                                                            <Form.Text className="form-text text-danger mb-2" >
                                                                                {this.state.submitError}
                                                                            </Form.Text>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                </Row>

                                            </>
                                        ) : (<p>
                                            {
                                                this.state.dataError != "" ?
                                                    (
                                                        <h6 className='mt-3 text-center' >{this.state.dataError}</h6>
                                                    )
                                                    :
                                                    ("")
                                            }
                                        </p>)
                                    }
                                </p>
                            )
                        }
                    </Col>
                </Row>
                <MaterialCreationModal
                    globals={this.props.globals}
                    stateData={this.state}
                    show={this.state.materialCreationModal}
                    onHide={() => this.setState({ materialCreationModal: false })}
                    getMaterialTypes={this.props.getMaterialTypes}
                />
            </Container>
        )
    }

}

export default withRouter(withApollo(compose(
    graphql(CREATE_MEATRIALS_ALLCATION, {
        name: "createMaterialAllocation"
    }),
)(MeatrialAssigning_to_Students))); 